import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function MagicVerify() {
  const [params] = useSearchParams();
  const { verifyMagicLink } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get("token");
    if (!token) return setError("This sign-in link is missing its token.");
    verifyMagicLink(token)
      .then(() => navigate("/saved", { replace: true }))
      .catch((e) => setError(formatApiErrorDetail(e.response?.data?.detail)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-paper-light flex items-center justify-center px-4" data-testid="magic-verify-page">
      {error ? (
        <div className="max-w-md text-center bg-white border border-[#e5e7eb] rounded-3xl p-8">
          <p className="text-[11px] font-bold uppercase tracking-[0.15em] text-gold">Sign in</p>
          <h1 className="mt-2 text-2xl font-extrabold text-ink" data-testid="magic-verify-error">That link didn't work</h1>
          <p className="mt-2 text-sm text-ink-muted">{error}</p>
          <Link to="/login" data-testid="magic-verify-retry" className="mt-6 inline-flex h-11 items-center px-6 rounded-full bg-gold text-ink font-semibold text-sm hover:bg-[#c19614]">Request a new link</Link>
        </div>
      ) : (
        <div className="text-center">
          <div className="w-10 h-10 mx-auto rounded-full border-2 border-gold border-t-transparent animate-spin" />
          <p className="mt-4 text-sm text-ink-muted" data-testid="magic-verifying">Signing you in…</p>
        </div>
      )}
    </div>
  );
}
